<template>
    <div class="drag-menber-list">
        <el-table :data="membersList.slice(0, 20)" ref="table">
            <el-table-column fixed type="index" width="40" />
            <el-table-column
                label="会员昵称" 
                min-width="180">
                <template v-slot="{ row }">
                    <user-info v-if="row.user" :userInfo="{
                        avatar: row.user.avatar,
                        nickname: row.user.nickname,
                        realname: row.name,
                        gender: row.user.gender
                    }" />
                </template>
            </el-table-column>
            <el-table-column 
                label="会员分组" 
                min-width="110">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ row.group.name }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="birthday" label="生日" min-width="120" sortable="custom"/>
            <el-table-column prop="balance" label="会员余额(元)" min-width="100" align="right" sortable="custom">
                <template v-slot="{ row }">
                    <span class="pr-24 text-popper" v-textPopper v-numberAlign>{{ row.balance }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="accumulated_recharge" label="累计充值(元)" min-width="100" align="right">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ row.accumulated_recharge }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="accumulated_consume" label="累计消费(元)" min-width="100" align="right">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ row.accumulated_consume }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="accumulated_consume_count" label="累计消费次数" min-width="100" align="right">
                <template v-slot="{ row }">
                    <span class="text-popper" v-textPopper>{{ row.accumulated_consume_count }}</span>
                </template>
            </el-table-column>
            <el-table-column min-width="20"/>
            <el-table-column label="操作" width="80">
                <template v-slot="{ row }">
                    <div class="operate fx-v-center">
                        <button class="text-btn" @click="$router.push({
                            path: '/main/member/memberDetail',
                            query: {
                                id: row.id
                            }
                        })">详情</button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <span class="count">{{membersList.length}}</span>
    </div>
</template>

<script>
export default {
    props: {
        membersList: {
            type: Array,
            default: () => []
        }
    },

    mounted() {
        this.$refs.table.toggleAllSelection()
    }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table__header-wrapper {
    display: none;
}

.count {
    position: absolute;
    left: -12px;
    top: -12px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #ee5b5b;
    color: #fff;
    z-index: 20;
}
</style>